export const endpoints = {
 email: {
  newsletters: "email/newsletters",
 },
 plans: "plans",
 paymentNiubiz: {
  generateToken: "paymentClient/generateToken",
  createSessionToken: "paymentClient/create-sessionToken",
 },
 user: {
  getEmail: "user/getEmail",
 },
};
